
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prompts",
      function () {
        return require("private-next-pages/prompts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prompts"])
      });
    }
  